import { css } from '@emotion/react';
import MuiGlobalStyles from '@mui/material/GlobalStyles'; // Import GlobalStyles from @mui/material

const GlobalStyles = () => {
  return (
    <MuiGlobalStyles
      styles={css`
        body {
          font-family: 'IBM Plex Sans', sans-serif;
          margin: 0;
          padding-right: 0 !important;
          overflow: auto !important;
          /* Font smoothing for better rendering across browsers */
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          /* Text rendering optimization */
          text-rendering: optimizeLegibility;
          /* Font feature settings for better number and text rendering */
          font-feature-settings: 'kern' 1;
        }
        @media (min-width: 768px) {
          body {
            background-color: #fafdfa !important;
          }
          .modal-container {
            position: fixed !important;
            max-width: 600px !important;
          }
        }
        .card-container {
          padding-bottom: 30px;
        }
        .usabilla_live_button_container {
          display: none !important;
        }
        .MuiBox-root {
          outline-style: none;
        }
        .referral-link {
          display: none;
        }
        .async-hide {
          opacity: 0 !important;
        }
        [class*='LoginModal'],
        [class*='loginModal'],
        .MuiDialog-root [class*='login'] {
          font-family: 'owners-text', 'Owners Text', 'IBM Plex Sans', system-ui, sans-serif;
        }
        [data-cy='invest-in-startengine-link'],
        [aria-describedby='reserveShares'] {
          display: none !important;
        }
        #trial_popup {
          display: none !important;
        }
      `}
    />
  );
};

export default GlobalStyles;
